<template>
  <div>
    <v-row>
      <v-col cols="12" sm="3">
        <v-select
          v-model="filter.lss"
          :items="$store.getters['admin/lsservers']"
          :label="$t('fields.lss')"
          item-value="idx"
          item-text="name"
          clearable
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="terminals"
      :search="search"
      :items-per-page.sync="itemPerPage"
      :page.sync="currentPage"
      item-key="idx"
      show-expand
      class="transparent"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:top>
        <v-btn fab absolute bottom @click="edit({status:1})" dark class="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:expanded-item="{item, headers}">
        <td :colspan="headers.length">
          <v-row>
            <v-col v-for="k in details" :key="k.value">
              <div class="subtitle-2">{{k.text}}</div>
              <div>{{format(item, k.value)}}</div>
            </v-col>
          </v-row>
        </td>
      </template>
      <template v-slot:item.action="{item}">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.status="{item}">{{$t("status.rec_"+item.status)}}</template>
      <template v-slot:item.lastUsed="{item}">{{item.lastUsed | dt-time}}</template>
      <template v-slot:item.lss="{item}">{{$store.getters['admin/lss'](item.lss).name}}</template>
      <!-- <template v-slot:item.keyfile="{ item }"><v-icon>{{item.keyfile?'mdi-check':''}}</v-icon></template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template v-slot:item.updated="{item}">{{item.updated | dt-time}}</template>-->
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="500">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <span>
            <i18n path="admin.terminal">
              <template #idx>{{item.idx}}</template>
            </i18n>
          </span>
          <v-spacer></v-spacer>
          <v-btn @click="d_edit=false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="item.terminal"
              :error-messages="terminal_errors"
              :label="$t('fields.terminalid')"
              :rules="[v=>!!v||$t('error.required')]"
            ></v-text-field>
            <v-text-field v-model="item.description" :label="$t('fields.description')"></v-text-field>
            <v-text-field
              v-model="item.operations"
              :label="$t('fields.operations')"
              :rules="[v=>(!v || /^\d+(,\d+)*$/g.test(v))||$t('error.digits')]"
            ></v-text-field>
            <v-select
              v-model="item.lss"
              :items="$store.getters['admin/lsservers']"
              :label="$t('fields.lss')"
              item-text="name"
              item-value="idx"
            ></v-select>
            <v-file-input
              v-model="keyfile"
              :label="$t('fields.keyfile')"
              :placeholder="item.keyfile"
              clearable
              @click.clear="item.keyfile=null"
            ></v-file-input>
            <v-text-field v-model="item.keypass" :label="$t('fields.keypass')"></v-text-field>
            <v-select v-model="item.status" :items="$t('statuses')" :label="$t('fields.status')"></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="d_confirm=true" color="primary">{{$t("button.delete")}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="update" color="primary">{{$t("button.update")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      v-model="d_confirm"
      :mode="dmode"
      @click:ok="remove"
    >{{$t("dialog.txt.delTerminal")}}</ConfirmDialog>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";

export default {
  name: "AdminTerminals",
  mixins: [commonmixin],
  data() {
    return {
      item: {},
      d_edit: false,
      keyfile: null,
      filter: {
        lss: null,
      },
      terminal_errors: "",
      details: [
        { text: this.$t("fields.created"), value: "created", align: "center" },
        { text: this.$t("fields.updated"), value: "updated", align: "center" },
        { text: this.$t("fields.operations"), value: "operations" },
        {
          text: this.$t("fields.keyfile"),
          value: "keyfile",
          align: "center",
        },
      ],
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
        { text: this.$t("fields.description"), value: "description" },
        { text: this.$t("fields.terminalid"), value: "terminal" },
        {
          text: this.$t("fields.last_used"),
          value: "lastUsed",
          align: "center",
        },
        { text: this.$t("fields.used"), value: "used", align: "center" },
        {
          text: this.$t("fields.bad_used"),
          value: "badUsed",
          align: "center",
        },
        {
          text: this.$t("fields.lss"),
          value: "lss",
          filter: (value) => {
            return !this.filter.lss || value === this.filter.lss;
          },
        },
        { text: this.$t("fields.status"), value: "status", align: "center" },
      ],
    };
  },
  methods: {
    format(i, k) {
      try {
        if (k == "created" || k == "updated" || k == "lastUsed")
          return this.$options.filters["dt-time"](i[k]);
        return i[k];
      } catch (error) {
        return error;
      }
    },
    edit(i) {
      //console.log(this.$store.getters["admin/lsservers"]);
      this.d_edit = true;
      this.item = { ...i };
      this.keyfile = null;
      this.currentIdx = this.terminals.indexOf(i);
    },
    remove() {
      this.$store.dispatch("admin/DELETE_TERMINAL", this.item).then(() => {
        this.d_edit = false;
      });
    },
    update() {
      if(!this.$refs.form.validate()) return;
      if (this.item.idx) {
        this.$store
          .dispatch("admin/UPDATE_TERMINAL", {
            item: this.item,
            index: this.currentIdx,
            file: this.keyfile,
          })
          .then(() => {
            this.d_edit = false;
          });
      } else {
        this.$store
          .dispatch("admin/INSERT_TERMINAL", {
            item: this.item,
            file: this.keyfile,
          })
          .then((response) => {
            if (response == 0) {
              this.terminals = this.$t("error.api");
            } else {
              this.d_edit = false;
            }
          });
      }
    },
  },
  computed: {
    terminals() {
      return this.$store.getters["admin/terminals"];
    },
  },
  mounted() {
    this.$store.dispatch("admin/LOAD_TERMINALS");
    if (!this.$store.getters["admin/isLss"]) {
      this.$store.dispatch("admin/LOAD_LSS");
    }
  },
};
</script>

<style scoped>
</style>